<template>
  <div>
    <div v-if="displayNoInsuranceMessage && !insurances.length">
      No insurances found
    </div>
    <div v-for="(insurance, i) in insurances" :key="i">
      <v-row class="ma-0 pa-0">
        <v-col
          cols="12"
          class="ma-0 pa-0"
        >
        <div>
          {{ insurance.Product?.name || insurance.name }} 
          <span v-if="insurance.insurance?.coverage" :class="durationPeriodColor" class="hb-font-caption pb-2">({{ insurance.insurance.coverage }} coverage)</span>
          <div v-if="insurancePolicySettingEnabled && insurance.number" :class="durationPeriodColor" class="hb-font-caption pb-1">Policy # {{ insurance.number }}</div>
        </div>          
          <div :class="durationPeriodColor" class="hb-font-caption pb-2">
            {{ insurance.start_date | formatDate }}
            <span v-if="insurance.end_date">- {{ getInsuranceEndDate(insurance) | formatDate }}</span> 
            <span v-else> onwards</span>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex';
  import SETTINGS from '@/constants/setting.js';

export default {
  name: "AllInsurances",
  data() {
    return {
      insurancePolicySettingEnabled: false,
    };
  },

  props: {
    insurances: {
      type: Array,
      required: true,
    },
    displayNoInsuranceMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    durationPeriodColor: {
      type: String,
      required: false,
      default: "hb-text-light",
    }
  },
  async created() {
    this.SETTINGS = SETTINGS;
    this.isInsuranceSettingEnabled();
  },
  computed: {
    ...mapGetters({
      insuranceSettings: 'settingsStore/insurance'
    }),
    
  },
  methods: {
    getInsuranceEndDate(insurance) {
      const start = insurance.start_date;
      const end = insurance.end_date;
      return end < start ? insurance.start_date : insurance.end_date;
    },
    isInsuranceSettingEnabled(){
      const insurancePolicySetting = this.insuranceSettings?.find(setting => setting.name === SETTINGS.ALLOW_INSURANCE_POLICY_NUMBER);
      console.log("insurancePolicySetting", insurancePolicySetting);
      if (insurancePolicySetting?.value) {
        this.insurancePolicySettingEnabled = parseInt(insurancePolicySetting.value) === 1;
      }
    },
  },
  watch: {
    insuranceSettings() { 
      this.isInsuranceSettingEnabled();
    }
  }
};
</script>

<style>
</style>